import { useContext } from "react";

import AuthContext from "./context";
import authStorage from "./storage";

const useAuth = () => {
  const { token, setToken } = useContext(AuthContext);
  // const { userType, setUserType } = useContext(AuthContext);

  const logIn = (authToken, name, location) => {
    // const user = jwtDecode(authToken);
    // setUserType(userType);
    // console.log(authToken, name, location, 'fskh');
    // setUser(user);
    setToken(authToken);
    authStorage.storeToken(authToken);
    authStorage.storeName(name);
    authStorage.storeLocation(location);
    // authStorage.storeUserType(userType);
  };

  const logOut = () => {
    setToken(null);
    // authStorage.removeUserType();
    authStorage.removeToken();
    authStorage.removeName();
    authStorage.removeLocation();
  };

  return { token, logIn, logOut };
};

export default useAuth;
